import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./pdp-featured-category.module.scss";
import LinkGenerator from "@lululemon/ecom-common/src/lib/link-generator";
import { Heading } from "@lululemon/ui-library";
import { ErrorBoundary } from "@lululemon/mwa-logger";
import { productEdHandleError } from "@lululemon/ecom-common/src/util/product-education-logger";
import {
  EVENT_CATEGORY,
  EVENT_TYPE,
  trackEvent,
} from "@lululemon/mwa-analytics";

/**
 * Featured CDPs for all PDP pages
 * @param categoryTitle - the title of the featured category
 * @param featuredCategories - list of featured categories
 */
const PDPFeaturedCategory = ({ categoryTitle, featuredCategories }) => {
  // throw new Error("An error occurred");
  if (featuredCategories.length <= 0) return null;
  return (
    <ErrorBoundary
      onError={(error) =>
        productEdHandleError(
          error,
          "Product Education Factory",
          "Product Education Factory"
        )
      }
    >
      <div className={classNames(styles.featureCategoryWrapper)}>
        <Heading
          tag="h4"
          className={classNames(styles.categoryHeading, "lll-text-small")}
        >
          {categoryTitle}
        </Heading>
        <div className={styles.featureCategoryCTALinkWrapper}>
          {featuredCategories?.map((featuredCategory) => (
            <LinkGenerator
              key={featuredCategory?.recUrlKeyword}
              className={classNames(
                "lll-link-primary",
                styles.featureCategoryCTALink
              )}
              href={featuredCategory?.recPageUrl}
              onClick={() => {
                if (typeof window !== "undefined")
                  window?.localStorage?.setItem("fromFeatureCDP", "pdp");
                trackEvent(EVENT_CATEGORY.COMPONENT_EVENT, {
                  eventSubType: EVENT_TYPE.INTERACTION,
                  component: {
                    id: "featured-categories",
                    type: "link",
                    text: featuredCategory?.recUrlKeyword,
                    position: -1,
                    totalCount: -1,
                  },
                });
              }}
            >
              {featuredCategory?.recUrlKeyword}
            </LinkGenerator>
          ))}
        </div>
      </div>
    </ErrorBoundary>
  );
};

PDPFeaturedCategory.propTypes = {
  categoryTitle: PropTypes.string,
  featuredCategories: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string,
    })
  ),
};

PDPFeaturedCategory.defaultProps = {
  categoryTitle: "",
  featuredCategories: [{}],
};

export { PDPFeaturedCategory };
